import dayjs from 'dayjs';

import { ShapeColor } from '@cast/design-system';

import { OOMKillDataPoint } from './types';

export const oomKillsColorMap: Record<string, ShapeColor> = {
  totalCount: 'red.300',
  unmanagedCount: 'red.100',
  managedCount: 'red.500',
};

export const fillerFn = (timestamp: Date): OOMKillDataPoint => ({
  timestamp: timestamp.toISOString(),
  managedCount: null,
  unmanagedCount: null,
});

/** Merge managed/unmanaged points that share a timestamp (required before fillGaps). */
export const mergeOomKillDataPoints = (
  items: OOMKillDataPoint[]
): OOMKillDataPoint[] => {
  const byTimestamp = new Map<string, OOMKillDataPoint>();

  for (const item of items) {
    const existing = byTimestamp.get(item.timestamp) ?? {
      timestamp: item.timestamp,
      managedCount: null,
      unmanagedCount: null,
    };

    byTimestamp.set(item.timestamp, {
      timestamp: item.timestamp,
      managedCount: item.managedCount ?? existing.managedCount,
      unmanagedCount: item.unmanagedCount ?? existing.unmanagedCount,
    });
  }

  return [...byTimestamp.values()].sort((a, b) =>
    dayjs(a.timestamp).isAfter(b.timestamp) ? 1 : -1
  );
};
